// lib

import PropTypes from 'prop-types'

// components
import { Dropdown } from 'primereact/dropdown'
import { InputSwitch } from 'primereact/inputswitch'

// styles
import style from '@aytm/app/stats/page/question-views/info-view/components/styles/Control.module.scss'
import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'

const Control = ({ model, block, features, format, disabled, onChange }) => {
  const { subtype, text, values, displayValues, description, textReadonly = '' } = block

  return (
    <BlockWrapper>
      <div className={style.component}>
        {description != undefined ? (
          <div
            className={`${style['component-description']}${format.style != undefined ? ' ' + format.style : ''}`}
            dangerouslySetInnerHTML={{ __html: description }}
          ></div>
        ) : null}
        {features.xpert_controls.disabled ? (
          0 < textReadonly.length ? (
            <div className={style['component-title']} dangerouslySetInnerHTML={{ __html: textReadonly }}></div>
          ) : null
        ) : (
          <>
            <div className={style['component-title']}>{text}</div>
            <div className={style.row}>
              <span className="p-fluid" style={{ width: `${format.size || 250}px` }}>
                {'combobox' == subtype ? (
                  <Dropdown
                    className="p-dropdown-rounded"
                    aria-label={text}
                    ariaLabel={text}
                    value={model.value}
                    options={values.map((v, i) => {
                      return { text: displayValues[i], value: v }
                    })}
                    optionValue="value"
                    optionLabel="text"
                    fixedDropdownDir="bottom"
                    disabled={disabled}
                    onChange={disabled ? null : event => onChange(event.value)}
                  />
                ) : null}
                {'toggle' == subtype ? (
                  <>
                    <span>{displayValues[0]}</span>
                    <InputSwitch
                      aria-label={displayValues[1]}
                      checked={values[1] == model.value}
                      disabled={disabled}
                      onChange={disabled ? null : event => onChange(values[event.value ? 1 : 0])}
                    />
                    <span>{displayValues[1]}</span>
                  </>
                ) : null}
              </span>
              {model.loading ? (
                <span className={style['component-loader']}>
                  <i className="icon-aytmfd-refresh-v2 aytmfd-spin" />
                </span>
              ) : null}
            </div>
          </>
        )}
      </div>
    </BlockWrapper>
  )
}

Control.propTypes = {
  model: PropTypes.object,
  block: PropTypes.object,
  features: PropTypes.object,
  format: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
}

Control.displayName = 'Control'

export default Control
